import mapFunction from './mapResources';

export default mapFunction('entity_types', {
    isFetching: false,
    items: []
});